import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: API,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API service methods
export const quizAPI = {
  // Health check
  healthCheck: async () => {
    const response = await apiClient.get('/');
    return response.data;
  },

  // Question endpoints
  getAllQuestions: async () => {
    const response = await apiClient.get('/questions');
    return response.data;
  },

  getRandomQuestions: async (count = 10, categories = null, difficulty = null) => {
    const params = { count };
    if (categories && categories.length > 0) params.categories = categories.join(',');
    if (difficulty) params.difficulty = difficulty;
    
    const response = await apiClient.get('/questions/random', { params });
    return response.data;
  },

  seedQuestions: async () => {
    const response = await apiClient.post('/questions/seed');
    return response.data;
  },

  // Quiz session endpoints
  startQuiz: async (playerName = null, questionCount = 10, categories = null) => {
    const response = await apiClient.post('/quiz/start', {
      player_name: playerName,
      question_count: questionCount,
      categories: categories
    });
    return response.data;
  },

  getCategories: async () => {
    const response = await apiClient.get('/categories');
    return response.data;
  },

  getCategoryCounts: async () => {
    const response = await apiClient.get('/categories/counts');
    return response.data;
  },

  submitQuiz: async (sessionId, answers, completionTime) => {
    const response = await apiClient.post('/quiz/submit', {
      session_id: sessionId,
      answers: answers,
      completion_time: completionTime
    });
    return response.data;
  },

  getQuizResults: async (sessionId) => {
    const response = await apiClient.get(`/quiz/results/${sessionId}`);
    return response.data;
  },

  // Leaderboard and stats
  getLeaderboard: async (limit = 10) => {
    const response = await apiClient.get('/leaderboard', { params: { limit } });
    return response.data;
  },

  getStats: async () => {
    const response = await apiClient.get('/stats');
    return response.data;
  }
};

// CIE IGCSE Question Helper (pilot) endpoints
export const questionHelperAPI = {
  seed: async () => {
    const response = await apiClient.post('/qh/seed');
    return response.data;
  },
  getLegend: async () => {
    const response = await apiClient.get('/qh/legend');
    return response.data;
  },
  getPractice: async () => {
    const response = await apiClient.get('/qh/practice');
    return response.data;
  },
  saveAttempt: async (attempt) => {
    const response = await apiClient.post('/qh/attempts', attempt);
    return response.data;
  },
  getProgress: async (userId) => {
    const response = await apiClient.get(`/qh/progress/${userId}`);
    return response.data;
  },
  getValidation: async () => {
    const response = await apiClient.get('/qh/admin/validation');
    return response.data;
  }
};

// Error handler utility
export const handleAPIError = (error) => {
  if (error.response) {
    // Server responded with error status
    console.error('API Error:', error.response.data);
    return error.response.data.detail || 'An error occurred';
  } else if (error.request) {
    // Request made but no response
    console.error('Network Error:', error.request);
    return 'Network error. Please check your connection.';
  } else {
    // Something else happened
    console.error('Error:', error.message);
    return error.message;
  }
};

export default apiClient;